/**
 * Least Recently Used (LRU) cache implementation
 * @template T - Type of cache keys
 * @template U - Type of cache values
 */
export class LRUCache {
    maxSize;
    map = new Map();
    keys = [];
    constructor(maxSize = Infinity) {
        this.maxSize = maxSize;
    }
    has(k) {
        return this.map.has(k);
    }
    get(k) {
        const v = this.map.get(k);
        if (v !== undefined) {
            this.keys.push(k);
            if (this.keys.length > this.maxSize * 2) {
                this.keys = this.keys.splice(-this.maxSize);
            }
        }
        return v;
    }
    set(k, v) {
        this.map.set(k, v);
        this.keys.push(k);
        if (this.map.size > this.maxSize) {
            this.map.delete(this.keys.shift());
        }
    }
}
/**
 * Creates a memoized function with LRU caching
 * @template T - Cache key type
 * @template V - Cache value type
 * @template Args - Function argument types
 */
export function cached({ maxSize, getKey, getValue, }) {
    const cache = new LRUCache(maxSize);
    const get = (...args) => {
        const k = getKey(args);
        if (!cache.has(k)) {
            cache.set(k, getValue(args));
        }
        return cache.get(k);
    };
    get.cache = cache;
    get.getKey = getKey;
    get.getValue = getValue;
    return get;
}
/**
 * Creates a simple memoized function with default settings
 * @template V - Cache value type
 * @template Args - Function argument types
 */
export function simpleCache(getValue) {
    return cached({ maxSize: 10 ** 5, getKey: xs => xs.join(":"), getValue });
}
//# sourceMappingURL=LRUCache.js.map